let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("j9OUx"), load("l079e"), load("bV8sS"), load("44Li1")]).then(() => parcelRequire('k7fv3'));